import Decisions from "../order-sim/Decisions"
import { oioEngine } from "./engine"

/** /oio-sim/:threadId: the shared decisions page with the OIO's stages and rows. */
export default function OioDecisions() {
  return <Decisions engine={oioEngine} />
}
